import { useColorScheme } from '@mui/material'
import { CustomerPaymentOperation, OperationInformation } from '@src/types/loan/loan-operation'
import { ReactNode } from 'react'
import { ITableColumn } from './LoanCalendarTable-hook'
import styles from './LoanCalendarTable.module.css'
import LoanCalendarTableBody from './LoanCalendarTableBody'
import LoanCalendarTableHead from './LoanCalendarTableHead'

interface LoanCalendarTableCustomProps {
  rows: OperationInformation<CustomerPaymentOperation>[]
  columns: ITableColumn[]
  visibleColumns: Record<string, boolean>
  selectedPaymentIds: Set<string>
  onSelectionChange: (ids: Set<string>) => void
  showMore: boolean
  onShowMoreChange: (value: boolean) => void
  getRowClassName: (row: OperationInformation<CustomerPaymentOperation>, index: number) => string
  toolbar?: ReactNode
}

const LoanCalendarTableCustom = ({
  rows,
  columns,
  visibleColumns,
  selectedPaymentIds,
  onSelectionChange,
  showMore,
  onShowMoreChange,
  getRowClassName,
  toolbar,
}: LoanCalendarTableCustomProps) => {
  const { mode, systemMode } = useColorScheme()

  // Determine the effective mode (handle 'system' mode)
  const effectiveMode = mode === 'system' ? systemMode : mode
  const modeClass = effectiveMode === 'dark' ? styles['table--dark'] : styles['table--light']

  return (
    <div className={`${styles.table__wrapper} ${modeClass}`}>
      {toolbar}
      <table className={`${styles.table} ${styles['table--container']}`}>
        <LoanCalendarTableHead
          columns={columns}
          visibleColumns={visibleColumns}
          showMore={showMore}
          onShowMoreChange={onShowMoreChange}
          rows={rows}
          selectedPaymentIds={selectedPaymentIds}
          onSelectionChange={onSelectionChange}
        />
        <LoanCalendarTableBody
          rows={rows}
          columns={columns}
          visibleColumns={visibleColumns}
          selectedPaymentIds={selectedPaymentIds}
          onSelectionChange={onSelectionChange}
          getRowClassName={getRowClassName}
        />
      </table>
    </div>
  )
}

export default LoanCalendarTableCustom
